import { en } from './en';
import { tr, type TranslationKey } from './tr';

export type { TranslationKey } from './tr';

export const SUPPORTED_LANGUAGES = ['tr', 'en'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];
export const DEFAULT_LANGUAGE: Language = 'tr';

export const isLanguage = (value: unknown): value is Language =>
  typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);

const dictionaries: Record<Language, Readonly<Record<TranslationKey, string>>> = { tr, en };

export type TranslationParams = Readonly<Record<string, string | number>>;

/**
 * Looks up `key` in the dictionary of `language` and substitutes `{name}` placeholders.
 * Keys are type-checked, so a missing translation is a compile-time error rather than a blank label.
 */
export function translate(
  language: Language,
  key: TranslationKey,
  params?: TranslationParams,
): string {
  const template = dictionaries[language]?.[key] ?? dictionaries.en?.[key] ?? key;
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) => {
    const value = params[name];
    return value === undefined ? match : String(value);
  });
}
